import { PureComponent } from 'react';
import Routes from 'ContentUtils/Routes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ContentRoutes from 'ContentUtils/Routes';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UITextInput from 'UIComponents/input/UITextInput';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import * as StatusCodes from 'ContentUtils/enums/HttpStatusCodes';
import H2 from 'UIComponents/elements/headings/H2';
import { SUCCEEDED } from 'ContentUtils/constants/RequestStatus';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `ContentComponents.cmv2.fields.baseResource.${suffix}`;
const buttonI18nkey = suffix => `ContentComponents.buttons.${suffix}`;
export default function withCreateResourceModal(type) {
  return Comp => {
    class WithCreateResourceModal extends PureComponent {
      constructor(props) {
        super(props);
        this.onCreateModalOpen = this.onCreateModalOpen.bind(this);
        this.onCreateModalClose = this.onCreateModalClose.bind(this);
        this.onResourceNameChange = this.onResourceNameChange.bind(this);
        this.onCreateResource = this.onCreateResource.bind(this);
        this.openResource = this.openResource.bind(this);
        this.openNewResource = this.openNewResource.bind(this);
        this.onConflictError = this.onConflictError.bind(this);
        this.createResourceURL = this.createResourceURL.bind(this);
        this.onClickAddButton = this.onClickAddButton.bind(this);
        this.setHasLoadedOptions = this.setHasLoadedOptions.bind(this);
        this.renderCreateNewFooter = this.renderCreateNewFooter.bind(this);
        this.resourceWindow = null;
        const hasAnyOptions = !!props.options.length;
        this.state = {
          isOpen: false,
          resourceName: '',
          hasConflictError: false,
          hasLoadedOptions: hasAnyOptions,
          hasAnyOptions,
          isCreating: false
        };
      }
      componentDidMount() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          loadOptions
        } = this.props;
        if (!hasAnyOptions) {
          loadOptions('', this.setHasLoadedOptions);
        }
      }
      componentDidUpdate() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          options
        } = this.props;
        if (!hasAnyOptions && options.length) {
          this.setState({
            hasAnyOptions: true
          });
        }
      }
      setHasLoadedOptions() {
        this.setState({
          hasLoadedOptions: true
        });
      }
      onCreateModalOpen() {
        this.setState({
          isOpen: true,
          isCreating: false
        });
      }
      onCreateModalClose() {
        this.setState({
          isOpen: false,
          isCreating: false,
          resourceName: ''
        });
      }
      onResourceNameChange(evt) {
        this.setState({
          resourceName: evt.target.value
        });
        if (this.state.hasConflictError) {
          this.setState({
            hasConflictError: false
          });
        }
      }
      onConflictError() {
        this.setState({
          hasConflictError: true,
          isCreating: false
        });
      }
      createResourceURL(value) {
        switch (type) {
          case FieldTypes.FORM:
            return ContentRoutes.forms(value, this.props.redirectUrl);
          case FieldTypes.WORKFLOW:
            return ContentRoutes.workflows(value);
          case FieldTypes.FOLLOW_UP_EMAIL:
            return ContentRoutes.edit(value, 2);
          case FieldTypes.MENU:
            return ContentRoutes.advancedMenuSettings(value);
          default:
            return null;
        }
      }
      openResource() {
        return window.open(this.createResourceURL(this.props.value));
      }
      openNewResource(newId) {
        this.resourceWindow.location = this.createResourceURL(newId);
      }
      onCreateResource() {
        this.setState({
          isCreating: true
        });
        if (this.props.onCreateResource) {
          this.props.onCreateResource(this.state.resourceName, {
            onCreateModalClose: this.onCreateModalClose,
            onConflictError: this.onConflictError
          });
          return;
        }
        this.resourceWindow = this.openResource();
        this.props.createResource(this.state.resourceName).then(result => {
          if (result) {
            if (result.status === StatusCodes.CONFLICT) {
              this.onConflictError();
              return;
            }
            const newResourceId = result.id;
            if (newResourceId) {
              this.props.onFieldChange(newResourceId);
              this.openNewResource(newResourceId);
              this.onCreateModalClose();
            } else if (this.resourceWindow) {
              this.resourceWindow.close();
            }
          }
        }).catch(err => {
          setTimeout(() => {
            throw err;
          });
        });
      }
      onClickAddButton() {
        if (this.props.onClickAddButton) {
          this.props.onClickAddButton();
        }
        if (this.props.createResourceUrl) {
          window.open(this.props.createResourceUrl);
        } else {
          this.onCreateModalOpen();
        }
      }
      getResourceTypeLabel(count = 1) {
        return I18n.text(i18nKey(`typeLabels.${type}`), {
          count
        });
      }
      renderCreateResourceModal() {
        const {
          external
        } = this.props;
        const {
          isOpen,
          resourceName,
          hasConflictError
        } = this.state;
        if (!isOpen) return null;
        const typeLabel = this.getResourceTypeLabel();
        const conflictErrorMessage = hasConflictError && /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('conflictErrorMessage'),
          options: {
            type: typeLabel
          }
        });
        return /*#__PURE__*/_jsxs(UIModal, {
          children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
            children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
              onClick: this.onCreateModalClose
            }), /*#__PURE__*/_jsx(H2, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('create'),
                options: {
                  type: typeLabel
                }
              })
            })]
          }), /*#__PURE__*/_jsx(UIDialogBody, {
            children: /*#__PURE__*/_jsx(UIFormControl, {
              error: hasConflictError,
              validationMessage: conflictErrorMessage,
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('name')
              }),
              children: /*#__PURE__*/_jsx(UITextInput, {
                value: resourceName,
                onChange: this.onResourceNameChange
              })
            })
          }), /*#__PURE__*/_jsxs(UIDialogFooter, {
            children: [/*#__PURE__*/_jsxs(UILoadingButton, {
              loading: this.state.isCreating,
              disabled: !resourceName,
              onClick: this.onCreateResource,
              use: "primary",
              children: [/*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nkey('create')
              }), external ? /*#__PURE__*/_jsx(UIIcon, {
                name: "externalLink"
              }) : null]
            }), /*#__PURE__*/_jsx(UIButton, {
              onClick: this.onCreateModalClose,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: buttonI18nkey('cancel')
              })
            })]
          })]
        });
      }
      renderCreateNewFooter() {
        return Routes.isUngated('CMv2:SelectResourceActionsUpdates') && /*#__PURE__*/_jsx(UIButton, {
          onClick: this.onClickAddButton,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('add')
          })
        });
      }
      renderEditAddControls() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          addTooltip,
          disableAdd,
          disabled,
          disableEdit,
          editTooltip,
          external,
          onEditResource,
          value
        } = this.props;
        let editButton;
        if (hasAnyOptions) {
          editButton = /*#__PURE__*/_jsxs(UIButton, {
            "data-selenium": "edit-resource-button",
            use: "tertiary-light",
            disabled: !value || disabled || disableEdit,
            onClick: onEditResource || this.openResource,
            size: "extra-small",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: buttonI18nkey('edit')
            }), external ? /*#__PURE__*/_jsx(UIIcon, {
              name: "externalLink"
            }) : null]
          });
          if (editTooltip) {
            editButton = /*#__PURE__*/_jsx(UITooltip, {
              title: editTooltip,
              placement: "top right",
              children: editButton
            });
          }
        }
        let addButton = (!Routes.isUngated('CMv2:SelectResourceActionsUpdates') || !hasAnyOptions) && /*#__PURE__*/_jsx(UIButton, {
          "data-selenium": "create-resource-button",
          disabled: disabled || disableAdd,
          use: "tertiary-light",
          onClick: this.onClickAddButton,
          size: "extra-small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(hasAnyOptions ? 'add' : 'firstAdd'),
            options: {
              type: this.getResourceTypeLabel()
            }
          })
        });
        if (addButton && addTooltip) {
          addButton = /*#__PURE__*/_jsx(UITooltip, {
            title: addTooltip,
            placement: "top right",
            children: addButton
          });
        }
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(View, {
            marginBlockStart: "200",
            as: "div",
            children: [editButton, addButton]
          }), this.renderCreateResourceModal()]
        });
      }
      renderComponent() {
        const {
          hasAnyOptions
        } = this.state;
        const {
          optionsRequestStatus
        } = this.props;
        if (optionsRequestStatus === SUCCEEDED && !hasAnyOptions) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('emptyMessage'),
            options: {
              type: this.getResourceTypeLabel(2)
            }
          });
        }
        return /*#__PURE__*/_jsx(Comp, Object.assign({}, this.props, {
          createNewFooter: this.renderCreateNewFooter()
        }));
      }
      render() {
        const {
          hasLoadedOptions
        } = this.state;
        if (!hasLoadedOptions) return /*#__PURE__*/_jsx(UILoadingSpinner, {});
        return /*#__PURE__*/_jsxs("div", {
          children: [this.renderComponent(), this.renderEditAddControls()]
        });
      }
    }
    WithCreateResourceModal.defaultProps = {};
    WithCreateResourceModal.displayName = 'WithCreateResourceModal';
    return WithCreateResourceModal;
  };
}